import React, { Component, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';

import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Icon from '@mui/material/Icon';

import classes from './EmptyResults.scss';

export default class EmptyResults extends Component {

  static propTypes = {
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    emptyText: PropTypes.node,
    className: PropTypes.string,
    actions: PropTypes.node,
    elevation: PropTypes.number,
    textGutterTop: PropTypes.bool,
  }

  static defaultProps = {
    elevation: 0,
    square: true,
    textGutterTop: true
  }

  render() {
    const { icon, emptyText, className, actions, textGutterTop, ...others } = this.props;
    const iconProps = {
      classes : { fontSizeInherit: classes.icon },
      fontSize: 'inherit',
      color   : 'primary',
    }

    return (
      <Card {...others} className={classes.container + ' ' + (className || '')}>
        <CardContent>
          <div className={classes.title}>
            {icon && (isValidElement(icon) ?
              cloneElement(icon, iconProps) :
              <Icon {...iconProps}>{icon}</Icon>
            )}
            <br/>
            {textGutterTop && <br/>}
            {emptyText}
          </div>
        </CardContent>
        {actions && (
          <CardActions classes={{root: classes.cardActions}}>
            {actions}
          </CardActions>
        )}
      </Card>
    );
  }

}
